import { observer } from "mobx-react-lite";
import { Autocomplete, Checkbox, Chip, Divider, Grid, TextField, Typography } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import React, { useEffect, useRef, useState } from "react";
import { useMst } from "../../../../../mobx";
import { CheckBox as CheckBoxIcon, CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon } from "@mui/icons-material";
import { useKatex } from "../../../../../helpers/hooks/useKatex";

interface TexHelpersSelectorProps {
	prefix?: string;
}

export default observer(function ({ prefix }: TexHelpersSelectorProps) {
	const { texHelpersStore } = useMst();
	const { getTexHelpers, texHelpersData } = texHelpersStore;
	const { control, setValue } = useFormContext();
	const [loading, setLoading] = useState(false);

	const onOpen = async () => {
		setLoading(true);
		await getTexHelpers();
		setLoading(false);
	};

	return (
		<Controller
			control={control}
			name={`${prefix}tex_helpers`}
			defaultValue={[]}
			render={({ field: { value, onChange } }) => (
				<Autocomplete
					value={value}
					onChange={(_, value) => onChange(value)}
					multiple
					fullWidth
					loading={loading}
					loadingText={"Загрузка..."}
					noOptionsText={"Нет опций"}
					onOpen={onOpen}
					disableCloseOnSelect
					renderInput={(params) => (
						<TextField
							{...params}
							variant="outlined"
							margin={"dense"}
							size={"small"}
							label={"Подсказка по вводу ответа"}
							placeholder={"Выберите подсказку"}
						/>
					)}
					getOptionLabel={(option) => option.code}
					renderTags={(values, getTagProps) =>
						values.map((value, i) => (
							<Chip
								color={"primary"}
								size={"small"}
								variant={"outlined"}
								label={value.code}
								{...getTagProps({ index: i })}
							/>
						))
					}
					renderOption={(props, option, { selected }) => (
						<RenderOption key={option.code} {...props} code={option.code} selected={selected} text={option.text} />
					)}
					options={texHelpersData}
				/>
			)}
		/>
	);
});

function RenderOption({ selected, code, text, ...props }: { selected: boolean; code: string; text: string }) {
	const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
	const checkedIcon = <CheckBoxIcon fontSize="small" />;
	const ref = useRef(null);
	useKatex(ref, []);

	return (
		<li ref={ref} {...props}>
			<Grid container>
				<Grid container item wrap={"nowrap"} alignItems={"center"}>
					<Grid item>
						<Checkbox icon={icon} checkedIcon={checkedIcon} checked={selected} />
					</Grid>
					<Grid item>{code}</Grid>
				</Grid>
				<Grid container item sx={(theme) => ({ padding: theme.spacing(0, 4) })}>
					<Typography variant={"caption"} dangerouslySetInnerHTML={{ __html: text }} />
				</Grid>
			</Grid>
			<Divider sx={(theme) => ({ margin: theme.spacing(1, 0) })} />
		</li>
	);
}
